import React from 'react';

import img from '../../images/form-banner.png';
import { Container, Imagem } from './styles';

export default function AuthLayout({ children }) {
  return (
    <Container>
      <Imagem src={img} alt="imagem" style={{ width: '100%' }} />
      {children}
    </Container>
  );
}
